import React from "react";
import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";

/**
 * A clickable <th> that drives useSortableData. Renders a neutral sort icon when
 * inactive and an up/down chevron for the active column, matching the existing
 * DriverGrid look. Use `label` (or children) for the header text.
 */
const SortableHeader = ({ label, children, sortKey, sortConfig, onSort, className, style }) => {
    const active = sortConfig && sortConfig.key === sortKey;
    const direction = active ? sortConfig.direction : null;

    return (
        <th
            onClick={() => onSort(sortKey)}
            className={className}
            style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap", ...style }}
        >
            {label ?? children}{" "}
            {active ? (
                direction === "asc" ? <FaSortUp /> : <FaSortDown />
            ) : (
                <FaSort style={{ opacity: 0.3 }} />
            )}
        </th>
    );
};

export default SortableHeader;
